module.exports = __webpack_public_path__ + "img/icon-authenticator.25b5026f.svg";